exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mql-table[data-v-05eb3dce] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.mql-table .el-table[data-v-05eb3dce] {\n    overflow: auto;\n}\n.mql-table .mql-pagination[data-v-05eb3dce] {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05eb3dce","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"C://Users//Administrator//Desktop//project//admin//mql_admin_pc//src//assets//style//var-fun.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/core/MqlTable/index.vue
// module id = /E0V
// module chunks = 78